import axios from "axios";
import { basicurl } from "../ServiceUrl/url";

const token = window.sessionStorage.getItem("user_token");

export const GetDashboardDataService = async () => {
    let res = await axios.get(
        `${basicurl}/api/dashboard/get-dashboard-data`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return res;
};

export const getUniversityContacts = async ({ type, search = "" }) => {
    const res = await axios.get(
        `${basicurl}/api/dashboard/get-university-contacts`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: { type, search },
        }
    );
    return res;
};


export const getGlobalSearch=async (searchString)=>{
    let res = await axios.get(
        `${basicurl}/api/search/all`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: { q: searchString },
        }
    );
    return res;
}

export const GetDashboardSummaryService = async ({ intake = "", universityId = "", organizationId = "" } = {}) => {
    const params = new URLSearchParams();
    if (intake) params.append("intake", intake);
    if (universityId) params.append("universityId", universityId);
    if (organizationId) params.append("organizationId", organizationId);
    
    let res = await axios.get(
        `${basicurl}/api/student/get-dashboard-summary?${params.toString()}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return res;
};
